export default "__VITE_ASSET__26d79672__"